<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add"  v-show="empType=='ADMIN'">新增</Button>
		</div>
		<div class="list-btn">
			<div class="jiams">
				<div>商品类别：</div>
				<Cascader :data="data4" :load-data="loadData" :change-on-select="true" :not-found-text="kong" @on-change="onChange" ></Cascader>
				<!-- <Select v-model="query.typeId" multiple style="width:300px"  @on-change="onchangeSousuo">
				        <Option v-for="item in types" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select> -->
			</div>
			<Input style="width: 450px;" search enter-button placeholder="请输入商品名称/条形码" v-model="query.like" @on-search="onsearch"/>
			
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading" :height="h1">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">详情</Button>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize" v-if="showPage"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				h1:0,
				empType:'',
				//级联属性
				data4:[],
				kong:'暂无下级',
				//级联属性
				loading:false,
				total: 0,
				types:[],
				query: {
					page: 0,
					size: 10,
					typeId:'',
					like:''
				},
				columns12: [{
						title: 'id',
						key: 'id',
						width:120,
						align:'center',
					},{
						title: '图片',
						key: 'imgUrl',
						width:150,
						align:'center',
						render: (h, params) => {
							const row = params.row;
							
							return h('div', [
								h('img', {
									style: {
										width: "100px",
										height:'100px',
										verticalAlign: "middle"
									},
									attrs: {
										src: params.row.imgUrl
									}
								}, )
							]);
						}
					}, 
					{
						title: '名称',
						key: 'name',
						width:200,
						align:'center',
						render: (h, params) => {
							return h("div", params.row.name + "/" + params.row.unit)
						}
					},
					{
						title: '规格',
						width:200,
						align:'center',
						key: 'specification'
					},
					{
						title: '类别',
						width:200,
						align:'center',
						key: 'operComType',
						render: (h, params) => {
							return h("div", params.row.operComType.typeName1 + "/" + params.row.operComType.typeName2 + "/"+params.row.operComType.typeName3 )
						}
					},
					{
						title: '生产厂家',
						width:200,
						align:'center',
						key: 'manuString'
					},
					{
						title: '条形码',
						width:200,
						align:'center',
						key: 'barCode'
					},
					{
						title: '进价',
						key: 'purchasingPrice',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div", params.row.purchasingPrice / 100 + '元')
						}
					},
					{
						title: '售价',
						key: 'sellPrice',
						width:120,
						align:'center',
						render: (h, params) => {
							return h("div", params.row.sellPrice / 100 + '元')
						}
					},
					/* {
						title: '单位',
						key: 'unit'
					}, */
					{
						title: '录入时间',
						width:200,
						align:'center',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 100,
                        fixed: 'right',
						align: 'center'
					}
				],
				data6: [
					/* {
						id: '1',
						name: '雪碧',
						operComType: '饮料',
						purchasingPrice:'5.5元',
						sellPrice: '6.5元',
						unit: '瓶',
						createdTime: '2010-10-10',
						updateTime: '2010-10-10'
						
					} */
				]

			}
		},
		created() {
			this.empType = JSON.parse(sessionStorage.getItem("user")).empType
			console.log(this.empType)
			this.ajaxPage();
			this.queryType(0)
			
			var hegiht = document.documentElement.clientHeight- 390
			
			this.h1 = hegiht
		},
		//监听屏幕变化
		mounted () {
		 const that = this
		 window.onresize = () => {
			 return (() => {
				var hegiht = document.documentElement.clientHeight- 390
				this.minHeight = hegiht
			this.h1 = hegiht
			 })()
		 }
		},
		methods: {
			onsearch(){
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			onChange(a){
				if(a[2]!=undefined){
					this.query.typeId=a[2]
					this.query.page=0
					this.showPage = false
					this.$nextTick(() => {
						this.showPage = true
					}) 
					this.ajaxPage()
				}else{
					console.log(a)
					if(a.length==0){
					    this.query.typeId=null
					    this.query.page=0
						this.showPage = false
						this.$nextTick(() => {
							this.showPage = true
						}) 
						this.ajaxPage()
					}
				}
				
			},
			loadData(item, callback){
				let _this=this
				
                item.loading = true;
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/oper/all',
				    data: {page:0,size:1000,level:0,parentId:item.value},
					_this: _this,
					success: function(data) {
						for (let i = 0; i < data.page.content.length; i++) {
							let a1={}
							let aa=data.page.content[i]
							console.log(aa.level,'2')
							if(aa.level!='2'){
								a1={
									value: '',
									label: '',
									children: [],
									loading: false
								}
							}else{
								a1={
									value: '',
									label: '',
								}
							}
							
							a1.value=aa.id
							a1.label=aa.name
							item.children.push(a1)
						}
						
						item.loading = false;
						callback();
					}
				  })
			},
            queryType(parentId) {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/oper',
				    data: {page:0,size:1000,level:0,parentId:parentId},
					_this: _this,
					success: function(data) {
						_this.types = data.page.content
						for (let i = 0; i < _this.types.length; i++) {
							let a1={
								value: '',
								label: '',
								children: [],
								loading: false
							}
							let aa=_this.types[i]
							a1.value=aa.id
							a1.label=aa.name
							_this.data4.push(a1)
						}
					}
				  })
				
			},
			onchangeSousuo(){
				this.query.page=0
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			update(id) { //修改
				this.$router.push({
					name: 'oper/comm/update',
					query: {
						id: id
					}
				})
			},
			add() {
				this.$router.push({
					name: 'oper/comm/add'
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				let _this = this
				this.loading = true
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/oper/operComMerchandise/page',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content

						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			}
		},
		components: {
			page
		},
		activated(){
			this.ajaxPage();
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		
	}
	.jiams{
		display: flex;
		align-items: center;
	}
	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/comm/list.vue